type Props = { size?: number; color?: string };

export function IconClose({ size = 20, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2.4"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<path d="M6 6l12 12M18 6L6 18" />
		</svg>
	);
}
